import { gql } from '@apollo/client'
import { BlockFragment } from 'app/features/shared/blocks'
import { BaseArticleBlock } from '../blocks.types'

export const ArticleGridBlockFragment: BlockFragment = {
  name: 'articleGrid',
  fragment: gql`
    fragment articleGrid on ArticleGrid {
      id
      blockName
      blockType
      articles {
        id
        title
        shortDescription
        featuredImage {
          url
          alt
        }
        primaryCategory {
          name
          slug
        }
        slug
      }
      articleGridLimit: limit
      articleGridDisplayStyle: displayStyle
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
  partialFragment: `
    ...on ArticleGrid {
      id
      blockName
      blockType
      articles {
        id
        title
        shortDescription
        featuredImage {
          url
          alt
        }
        primaryCategory {
          name
          slug
        }
        slug
      }
      articleGridLimit: limit
      articleGridDisplayStyle: displayStyle
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
}

export const ArticleGridBlockType = 'articleGrid'

export interface ArticleGridBlock extends BaseArticleBlock {
  blockType: typeof ArticleGridBlockType
  articles: {
    id: string
    title: string
    shortDescription: string
    featuredImage: {
      url: string
      alt: string
    }
    primaryCategory: {
      name: string
      slug: string
    }
    slug: string
  }[]
  imagePriority?: boolean
  articleGridLimit: number
  articleGridDisplayStyle: string
}
